export default {
  'categories.shoes': 'Buty',
  'categories.hoodies': 'Bluzy / Swetry',
  'categories.tshirts': 'Koszulki',
  'categories.jackets': 'Kurtki',
  'categories.pants': 'Spodnie / Szorty',
  'categories.headwear': 'Nakrycia głowy',
  'categories.sets': 'Zestawy',
  'categories.underwear': 'Bielizna',
  'categories.jersey': 'Koszulki sportowe',
  'categories.accessories': 'Akcesoria',
  'categories.bags': 'Torby',
  'categories.belts': 'Paski',
  'categories.perfumes': 'Perfumy',
  'categories.other': 'Inne rzeczy',
};